import { render } from "./TentangPage.vue?vue&type=template&id=f1fa6c7a"
import script from "./TentangPage.vue?vue&type=script&lang=js"
export * from "./TentangPage.vue?vue&type=script&lang=js"

import "./TentangPage.vue?vue&type=style&index=0&id=f1fa6c7a&lang=css"

import exportComponent from "/builds/christinandrea/kel1-kedaireka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__